import i18n from 'i18n';
import {
  ChooseAgencyStrategy,
  SiteAnnouncementAttachmentValue,
  SiteAnnouncementImageValue
} from 'core/siteAnnouncement/SiteAnnouncement';
import styles from './siteAnnouncementReadOnlyFields.module.scss';

// Read-only renderers used when editing an already-published announcement:
// the locked fields are shown as plain values instead of editable inputs.

export const renderReadOnlyImage = (image: SiteAnnouncementImageValue) => {
  const src = image?.url || image?.imgBase64;
  if (!src) {
    return (
      <div className={'col-form-label label form-label'}>
        {i18n.t('common.labels.noData')}
      </div>
    );
  }
  return (
    <img
      className={styles.image}
      src={src}
      alt={i18n.t('siteAnnouncementForm.labels.imageUrl')}
    />
  );
};

export const renderReadOnlyAttachments = (
  attachments: SiteAnnouncementAttachmentValue[]
) => {
  if (!attachments || attachments.length === 0) {
    return (
      <div className={'col-form-label label form-label'}>
        {i18n.t('common.labels.noData')}
      </div>
    );
  }
  return (
    <div className={'col-form-label label form-label'}>
      {attachments.map((attachment) => attachment.name).join(', ')}
    </div>
  );
};

export const renderReadOnlyAgencies = (
  chooseAgencyStrategy: ChooseAgencyStrategy,
  agencyIds: string[],
  agencyOptions: SelectOptions[]
) => {
  if (chooseAgencyStrategy === ChooseAgencyStrategy.ALL) {
    return (
      <div className={'col-form-label label form-label'}>
        {i18n.t('siteAnnouncementForm.labels.allAgencies')}
      </div>
    );
  }
  const labels = agencyIds.map((agencyId) => {
    const matched = agencyOptions.find(
      (option) => String(option.value) === agencyId
    );
    return matched ? matched.label : agencyId;
  });
  return (
    <div className={'col-form-label label form-label'}>
      {labels.length > 0 ? labels.join(', ') : i18n.t('common.labels.noData')}
    </div>
  );
};
